import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { PlatformAdmin, PlatformAdminCreate, AuditLog } from '../types/api.types'

export interface AuditLogFilters {
  entity?: string
  action?: string
  actor_user_id?: number
  limit?: number
  offset?: number
}

export const platformAdminService = {
  async getAll(): Promise<PlatformAdmin[]> {
    const { data } = await axiosInstance.get<PlatformAdmin[]>(API_ENDPOINTS.PLATFORM_ADMINS)
    return data
  },

  async create(payload: PlatformAdminCreate): Promise<PlatformAdmin> {
    const { data } = await axiosInstance.post<PlatformAdmin>(API_ENDPOINTS.PLATFORM_ADMINS, payload)
    return data
  },

  async toggleStatus(id: number, isActive: boolean): Promise<PlatformAdmin> {
    const { data } = await axiosInstance.patch<PlatformAdmin>(
      API_ENDPOINTS.PLATFORM_ADMIN_STATUS(id),
      { is_active: isActive },
    )
    return data
  },

  async delete(id: number): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.PLATFORM_ADMIN_BY_ID(id))
  },

  async getAuditLogs(filters: AuditLogFilters = {}): Promise<AuditLog[]> {
    const params = new URLSearchParams()
    if (filters.entity) params.set('entity', filters.entity)
    if (filters.action) params.set('action', filters.action)
    if (filters.actor_user_id) params.set('actor_user_id', String(filters.actor_user_id))
    if (filters.limit) params.set('limit', String(filters.limit))
    if (filters.offset) params.set('offset', String(filters.offset))

    const url = params.toString()
      ? `${API_ENDPOINTS.PLATFORM_AUDIT_LOGS}?${params.toString()}`
      : API_ENDPOINTS.PLATFORM_AUDIT_LOGS

    const { data } = await axiosInstance.get<AuditLog[]>(url)
    return data
  },
}
